import React, { Fragment, PropsWithChildren } from 'react';

import { Typography, Box } from '@mui/material';
import {
  SearchFieldsStyled,
  ToolBarStyled,
  SearchContainer,
  RightToolbarStyled
} from './form-toolbar.style';

function FormToolbar({ children }: { children: React.ReactNode }): JSX.Element {
  return <ToolBarStyled sx={{ p: { xs: 0, md: 0 } }}>{children}</ToolBarStyled>;
}
FormToolbar.Left = function FormToolbarLeft({
  title,
  subTitle,
  children
}: PropsWithChildren<{
  title?: string;
  subTitle?: string | React.ReactNode;
}>): JSX.Element {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          columnGap: '12px',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}
      >
        {title ? (
          <Typography variant='h2' sx={{ color: 'primary.dark' }}>
            {title}
          </Typography>
        ) : null}
        {children}
      </Box>
      {subTitle ? (
        <Typography variant='caption' color='GrayText' sx={{ paddingLeft: '2px' }}>
          {subTitle}
        </Typography>
      ) : null}
    </Box>
  );
};

FormToolbar.SearchFields = function FormToolbarLeft({
  children
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <SearchContainer>
      <SearchFieldsStyled sx={{ marginRight: 0 }}>{children}</SearchFieldsStyled>
    </SearchContainer>
  );
};

FormToolbar.Right = function FormToolbarRight({
  children
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <Fragment>
      <Box sx={{ flexGrow: 1 }} />
      <RightToolbarStyled>{children}</RightToolbarStyled>
    </Fragment>
  );
};

export { FormToolbar };
